import React from 'react';

interface SectionHeaderProps {
  title: string | React.ReactNode;
  subtitle: string;
  center?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, center = false }) => {
  return (
    <div className={`mb-16 ${center ? 'text-center' : 'text-left'}`}>
      <h4 className="text-astral-purple font-mono text-sm tracking-widest uppercase mb-3 flex items-center gap-3 justify-center md:justify-start">
        {center && <span className="h-[1px] w-8 bg-astral-purple"></span>}
        {subtitle}
        <span className="h-[1px] w-8 bg-astral-purple"></span>
      </h4>
      <h2 className="text-4xl md:text-5xl font-display font-bold uppercase tracking-widest text-white leading-tight break-words">
        {title}
      </h2>
    </div>
  );
};